import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import { useScrollToSection } from '../hooks/useScrollToSection';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  useScrollToSection();

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            GetStrandX
          </Link>
          <div className="nav-links">
            <Link to="/about" className="nav-link">About</Link>
            <Link to="/#learn-diy" className="nav-link">Learn DIY</Link>
            <Link to="/privacy" className="nav-link">Privacy</Link>
            <Link to="/terms" className="nav-link">Terms</Link>
            <Link to="/#prelaunch-survey" className="nav-link cta-link">Get Early Access</Link>
          </div>
        </div>
      </nav>
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
